import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query/react';
import { apiSlice } from '../api/apiSlice';
import { persistedReducer } from './rootReducer';
//import persistStore from "redux-persist/es/persistStore";
import {
	FLUSH,
	PAUSE,
	PERSIST,
	PURGE,
	REGISTER,
	REHYDRATE,
    persistStore,
} from "redux-persist";

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: [
                FLUSH,
                REHYDRATE,
                PAUSE,
                PERSIST,
                PURGE,
                REGISTER,
            ],
        },
      }).concat(apiSlice.middleware),
    devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);

/* // Load initial data from localForage into Redux store
const loadInitialData = async () => {
  const storedUsers = await localForage.getItem('user');
  if (storedUsers) {
    store.dispatch(setUserFromLocalStorage(storedUsers as any));
  }
};

// Initialize data loading
loadInitialData(); */

// Set up listeners for RTK Query (optional)
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;